import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { t } = useTranslation();
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (e2) {
      setErr(e2.response?.data?.detail || "Erreur");
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="admin-login" className="min-h-screen bg-[#050505] text-[#F8F5EF] flex items-center justify-center p-6">
      <form onSubmit={submit} className="w-full max-w-md luxe-card p-10">
        <div className="flex items-center gap-3 mb-8">
          <Lock className="text-[#D4AF37]" size={20} />
          <div>
            <div className="overline">Le 17 · Admin</div>
            <h1 className="font-serif-luxe text-3xl text-[#F8F5EF] mt-1">{t("admin.login_title")}</h1>
          </div>
        </div>
        <div className="space-y-5">
          <div>
            <label className="overline mb-2 block">{t("admin.email")}</label>
            <input data-testid="admin-email" required type="email" value={email} onChange={e=>setEmail(e.target.value)} className="input-luxe" autoComplete="username" />
          </div>
          <div>
            <label className="overline mb-2 block">{t("admin.password")}</label>
            <input data-testid="admin-password" required type="password" value={password} onChange={e=>setPassword(e.target.value)} className="input-luxe" autoComplete="current-password" />
          </div>
          {err && <div data-testid="admin-login-error" className="text-red-400 text-sm">{String(err)}</div>}
          <button data-testid="admin-login-submit" type="submit" disabled={loading} className="btn-gold w-full justify-center disabled:opacity-50">
            {loading ? "..." : t("admin.login_btn")}
          </button>
        </div>
      </form>
    </div>
  );
}
